// extracted by mini-css-extract-plugin
module.exports = {"title":"about_title__3cCwE","text":"about_text__IciN1"};